import {useControllers} from '../../../../../common/helpers/react/hooks/useControllers';
import {useNavigateTo} from "../../../../../common/helpers/react/hooks/useNavigateTo";

export const RolesPresenter = () => {
    useControllers().roles.clearSearchedRoles();
    useNavigateTo('roles/search');
    return <></>;
}